import { render } from "./boost-pagination.vue?vue&type=template&id=7e059a5c"
import script from "./boost-pagination.vue?vue&type=script&lang=js"
export * from "./boost-pagination.vue?vue&type=script&lang=js"

import "./boost-pagination.vue?vue&type=style&index=0&id=7e059a5c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__